var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarWeek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "15 25 105 25 105 105 15 105"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 25 105 25 105 45 15 45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    x2: 35,
    y1: 33,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    x2: 85,
    y1: 33,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 33,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 30,
    y1: 90,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    x2: 45,
    y1: 90,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 90,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    x2: 75,
    y1: 90,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 90,
    y2: 60
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/calendar-week.d71037b66ab2ad97e66e73885d2eea9c.svg";
export { ForwardRef as ReactComponent };